import constants from "./constants";
import request from "./request";
import isMobile from "ismobilejs";

let util = {
    getUrlQueryParam(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));

        // const params = new Proxy(new URLSearchParams(window.location.search), {
        //     get: (searchParams, prop) => searchParams.get(prop),
        //   });
        //   // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
        //   let value = params.some_key; // "some_value"
    },
    addGlobeCSS(cssText) {
        let existStyle = document.getElementById("globe-style");
        if (!existStyle) {
            existStyle = document.createElement("style");
            let head =
                document.head || document.getElementsByTagName("head")[0];
            existStyle.type = "text/css";
            existStyle.id = "globe-style";
            head.appendChild(existStyle);
        }

        //把创建的style元素插入到head中
        var textNode = document.createTextNode(cssText);
        if (existStyle.firstChild) {
            existStyle.replaceChild(textNode, existStyle.firstChild);
        } else {
            existStyle.appendChild(textNode);
        }
    },
    getCookie(name) {
        let matches = document.cookie.match(
            new RegExp(
                "(?:^|; )" +
                    name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
                    "=([^;]*)"
            )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    setCookie(name, value, props) {
        props = props || {};
        let exp = props.expires;
        if (typeof exp == "number" && exp) {
            let d = new Date();
            d.setTime(d.getTime() + exp * 1000);
            exp = props.expires = d;
        }
        if (exp && exp.toUTCString) {
            props.expires = exp.toUTCString();
        }
        value = encodeURIComponent(value);
        let updatedCookie = name + "=" + value;
        for (let propName in props) {
            updatedCookie += "; " + propName;
            let propValue = props[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }
        document.cookie = updatedCookie;
    },
    deleteCookie(name) {
        this.setCookie(name, null, {
            expires: -1,
        });
    },
    redirect(link) {
        window.location.href = link;
    },
    wrapLink(link) {
        return link.indexOf("http") >= 0 ? link : "http://" + link;
    },
    wrapApi(api) {
        // let loginToken = this.getLoginToken();
        // if (loginToken) {
        //     api += api.indexOf('?') >= 0 ? "&" : "?";
        //     api += `loginToken=${loginToken}`;
        // }
        return api;
    },
    updateUserConfig() {
        let self = this;
        return request
            .get(constants.apiHost + "/user/config")
            .then(function (result) {
                self.setUserConfig(result);
                return result;
            });
    },
    setUserConfig(userConfig) {
        // userConfig  .powerList | .platformType
        localStorage.setItem("UserConfig", JSON.stringify(userConfig));
    },
    getUserConfig() {
        let userConfigJson = localStorage.getItem("UserConfig");
        if (userConfigJson) {
            let userConfig = JSON.parse(userConfigJson);
            return userConfig;
        }
        return {};
    },
    setLoginUserInfo(userInfo) {
        // userInfo .userIdentityType | .userName | .userGender | .userPhone | .userPhoto
        localStorage.setItem("UserInfo", JSON.stringify(userInfo));
        localStorage.setItem("UI_Name", userInfo.userName);
        localStorage.setItem("UI_Avatar", userInfo.userAvatar);
        // // 读取 localStorage ‘myCat’ 数据项
        // let cat = localStorage.getItem('myCat');
        // // 移除 localStorage ‘myCat’ 数据项
        // localStorage.removeItem('myCat');
        // // 移除所有的 localStorage 数据项
        // localStorage.clear();
    },
    getLoginUserInfo() {
        let userInfoJson = localStorage.getItem("UserInfo");
        let userInfo = JSON.parse(userInfoJson);
        return userInfo;
    },
    removeLoginUserInfo() {
        localStorage.clear();
    },
    // getLoginToken() {
    //     let loginToken = localStorage.getItem('loginToken');
    //     return loginToken ? loginToken : "";
    // },
    // getUserId() {
    //     let userId = localStorage.getItem('userId');
    //     return userId ? userId : "";
    // },
    getUserName() {
        let userName = localStorage.getItem("UI_Name");
        return userName ? userName : "";
    },
    getUserAvatar() {
        let userAvatar = localStorage.getItem("UI_Avatar");
        return userAvatar ? userAvatar : "";
    },
    createPassword(min, max) {
        //可以生成随机密码的相关数组
        var number = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        var english = [
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
        ];
        var ENGLISH = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
        ];
        var special = [
            "~",
            "!",
            "@",
            "#",
            "$",
            "%",
            "^",
            "&",
            "*",
            "_",
            "+",
            "-",
            "=",
        ];
        var config = number.concat(english).concat(ENGLISH).concat(special);

        //先放入一个必须存在的
        var arr = [];
        arr.push(getOne(number));
        arr.push(getOne(english));
        arr.push(getOne(ENGLISH));
        arr.push(getOne(special));

        //获取需要生成的长度
        var len = min + Math.floor(Math.random() * (max - min + 1));

        for (var i = 4; i < len; i++) {
            //从数组里面抽出一个
            arr.push(config[Math.floor(Math.random() * config.length)]);
        }

        //乱序
        var newArr = [];
        for (var j = 0; j < len; j++) {
            newArr.push(arr.splice(Math.random() * arr.length, 1)[0]);
        }

        //随机从数组中抽出一个数值
        function getOne(arr) {
            return arr[Math.floor(Math.random() * arr.length)];
        }

        return newArr.join("");
    },
    getCode(phone, type = 1) {
        return request.get(constants.apiHost + "/utils/sms/getcode", {
            phone,
            type,
        });
    },
    getUserInfo(phone, code) {
        return request.get(constants.apiHost + "/user/getinfo", {
            phone,
            code,
            type: 11,
        });
    },
    getUserGenderForShow(gender) {
        if (1 == gender) {
            return "男";
        }

        if (2 == gender) {
            return "女";
        }

        return "";
    },
    getRegionForShow(region) {
        // console.log("111111 ~ file: util.js ~ line 189 ~ getRegionForShow ~ region", region);
        let regionForShow = [];

        if (region) {
            if (region.l1) {
                regionForShow.push(region.l1.regionName);
            }

            if (region.l2) {
                regionForShow.push(region.l2.regionName);
            }

            if (region.l3) {
                regionForShow.push(region.l3.regionName);
            }

            if (region.l4) {
                regionForShow.push(region.l4.regionName);
            }

            if (region.l5) {
                regionForShow.push(region.l5.regionName);
            }
        }

        return regionForShow.join(" ");
    },
    getLastRegionId(region) {
        if (region) {
            if (region.l5) {
                return parseInt(region.l5.regionId);
            }
            if (region.l4) {
                return parseInt(region.l4.regionId);
            }
            if (region.l3) {
                return parseInt(region.l3.regionId);
            }
            if (region.l2) {
                return parseInt(region.l2.regionId);
            }
            if (region.l1) {
                return parseInt(region.l1.regionId);
            }
        }

        return 0;
    },
    getRegionLevelForShow(level) {
        if (1 == level) {
            return "省级";
        }

        if (2 == level) {
            return "市级";
        }

        if (3 == level) {
            return "区县级";
        }

        if (4 == level) {
            return "街道级";
        }

        if (5 == level) {
            return "社区/村级";
        }

        return "";
    },
    getScale() {
        let scale = 1;
        let clientWidth = screen.width;
        if (clientWidth < 750) {
            scale = 750 / clientWidth;
        }
        return scale;
    },
    isMobile() {
        return isMobile(window.navigator).phone;
    },
    isRole(roles) {
        let userInfo = this.getLoginUserInfo();
        let userId = userInfo.userId;
        // let userConfig = this.getUserConfig();
        // let role = userConfig.platformType
        let isRole = roles.includes(userId);
        return isRole;
    },
    hasPower(power) {
        let userConfig = this.getUserConfig();
        let powerList = userConfig.powerList;
        let powers = [];
        powerList &&
            powerList.forEach((item) => {
                powers.push(item.power);
            });
        let hasPower = powers.includes(power);

        return hasPower;
    },
};

export default util;
